import TabFiltersFilters from "./TabFiltersFilters";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";

import axiApi from "ApiCaller";
import TabFiltersTableAssets from "./TabFiltersTableAssets";
import {isEvaluated} from "./ModelsDynamic";
import {SwalAlertClass} from "core/swalClass";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

// Criterios de un contenedor con los valores por defecto de la plantilla (DynamicParams)
class DynamicAssetModel {
    constructor(asset, params) {
        this.asset = asset;
        this.asset_id = asset.id;
        this.days = params.days;
        this.force = params.force;
        this.c1 = params.c1;
        this.c2 = params.c2;
        this.c3 = params.c3;
        this.is_asset = true;
        this.type = "asset";
    }
}

const TabFilters = ({
    formData,
    setFormData,
    dynamicAssets,
    assets,
    setAssets,
    setKeyTab,
    stepsTabs,
    iconograph,
    setIconograph,
    editing,
}) => {
    const {t: _CT} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [activeFilter, setActiveFilter] = useState(false);
    const [activeNext, setActiveNext] = useState(false);
    const [assetsCounter, setAssetsCounter] = useState(0);

    useEffect(() => {
        setActiveFilter(formData.filters.download_type && formData.filters.waste_type);
    }, [formData.filters.download_type, formData.filters.waste_type]);

    useEffect(() => {
        if (editing.data.filters) {
            // console.log("[TabFilters].useEffect()[editing.data.filters]");
            if (formData.filters.download_type && formData.filters.waste_type) {
                setActiveFilter(true);
                let params = {},
                    key,
                    value;

                for (key in formData.filters) {
                    if (!formData.filters[key] || formData.filters[key].length === 0) continue;
                    value = Array.isArray(formData.filters[key])
                        ? formData.filters[key].map((item) => item.id)
                        : formData.filters[key];
                    params[key] = value;
                }

                axiApi.get("/api/assets/filter/route/dynamic/", {params: params}).then((res) => {
                    setAssets(res.data.items);
                    setAssetsCounter(res.data.items.length);
                    setActiveNext(res.data.items.some(isEvaluated));
                    // - emulate handleClickNext();
                    dynamicAssets.current = buildDynamicAssets(res.data.items);
                    stepsTabs.setAddAssets(true);
                    stepsTabs.enableTab("criteria");
                    editing.set("criteria", true);
                });
            } else {
                setActiveFilter(false);
            }
        }
    }, [editing.data.filters]);

    const handleClickFilter = () => {
        let params = {},
            key,
            value;

        for (key in formData.filters) {
            if (formData.filters[key] === "") continue;
            value = Array.isArray(formData.filters[key]) ? formData.filters[key].map((item) => item.id) : formData.filters[key];
            params[key] = value;
        }

        axiApi.get("/api/assets/filter/route/dynamic/", {params: params}).then((res) => {
            setAssets(res.data.items);
            setAssetsCounter(res.data.items.length);
            setActiveNext(res.data.items.some(isEvaluated));
            stepsTabs.setAddAssets(false);
            stepsTabs.disableTab("criteria");
            stepsTabs.disableTab("preview");
            stepsTabs.setFiltersDynamic(false);
            stepsTabs.setClassifyAssets(false);
        });
    };

    // Contenedores seleccionados (activos) con sus criterios: los personalizados guardados o los de la plantilla
    const buildDynamicAssets = (items) => {
        const custom = new Map(formData.assets.map((item) => [item.asset_id, item]));
        return items
            .filter(isEvaluated)
            .map((item) =>
                custom.has(item.id)
                    ? {...custom.get(item.id), asset: item, is_asset: true, type: "asset"}
                    : new DynamicAssetModel(item, formData.params)
            );
    };

    const handleClickNext = () => {
        // Sin optimizar, el orden sale de una única ruta estática
        if (formData.params.optimize === false && formData.filters.routes.length !== 1) {
            Alert.warning(_CT("optimize-one-route"));
            return;
        }
        dynamicAssets.current = buildDynamicAssets(assets);
        stepsTabs.setAddAssets(true);
        stepsTabs.enableTab("criteria");
        setKeyTab("criteria");
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-3 col-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3>Filtros </h3>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={handleClickFilter}
                            disabled={!activeFilter}>
                            <FontAwesomeIcon icon="magnifying-glass" /> Filtrar
                        </button>
                    </div>
                    <TabFiltersFilters
                        formData={formData}
                        setFormData={setFormData}
                        icon={iconograph}
                        setIcon={setIconograph}
                        setActiveNext={setActiveNext}
                        stepsTabs={stepsTabs}
                        editing={editing}
                    />
                </div>
                <div className="col-md-9 col-12 border-start border-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3>
                            Contenedores: {assetsCounter}{" "}
                            <small className="text-muted">
                                (<FontAwesomeIcon icon="eye" /> {assets.filter(isEvaluated).length} seleccionados)
                            </small>
                        </h3>
                        <button type="button" className="btn btn-primary" onClick={handleClickNext} disabled={!activeNext}>
                            Siguiente
                        </button>
                    </div>

                    <TabFiltersTableAssets items={assets} />
                </div>
            </div>
        </div>
    );
};

export default TabFilters;
